import { asyncLoad } from '@util'

/**
 * @author  Ta_Mu
 * @date 2021/5/13 14:42
 */
export default [
  {
    path: 'serviceConfig',
    indexRoute: {
      component: asyncLoad(() =>
        import('@components/LocalMerchant/ServiceConfig')
      )
    }
  }
]
